// utils
import { modifyUrl } from './commonUtils';

export const getBreadcrumbUrl = (currentUrl, layer) => {
  const modifiedUrl = currentUrl.slice(0, currentUrl.lastIndexOf(`${layer}`));

  return modifyUrl(modifiedUrl);
};
